(() => {
  let catalogPromise;
  const catalog = () => catalogPromise ||= fetch(window.winterCatalogUrl).then(r => { if (!r.ok) throw Error('Catalog unavailable'); return r.json(); });
  const hydrate = async (root = document) => {
    const nodes = [...root.querySelectorAll('[data-winter-colors]:not([data-ready]),[data-winter-siblings]:not([data-ready])')];
    if (!nodes.length) return;
    let data;
    try { data = await catalog(); } catch { return; }
    for (const node of nodes) {
      const h = node.dataset.winterColors || node.dataset.winterSiblings;
      const group = data.groups[data.handles[h]] || [];
      if (!group.length) continue;
      node.dataset.ready = 'true';
      const isDetail = node.hasAttribute('data-winter-siblings');
      const list = document.createElement('div');
      list.className = isDetail ? 'winter-siblings' : 'winter-swatches';
      for (const color of group.slice(0,isDetail ? group.length : 6)) {
        const a = document.createElement('a');
        a.href = '/products/' + encodeURIComponent(color.handle);
        a.title = color.color;
        a.setAttribute('aria-label',color.color);
        a.className = 'winter-swatch' + (color.handle === h ? ' is-selected' : '');
        if (color.handle === h) a.setAttribute('aria-current','page');
        if (isDetail) {
          const img = document.createElement('img');
          img.src = color.image; img.alt = color.color; img.width=64; img.height=64; img.loading='lazy';
          a.append(img);
          const label = document.createElement('span'); label.textContent=color.color;a.append(label);
        } else {
          const shades=color.hex.split(',').filter(c=>/^#[0-9a-f]{3,8}$/i.test(c.trim()));
          if(shades.length===1) a.style.backgroundColor=shades[0];
          else if(shades.length>1) a.style.backgroundImage='linear-gradient(135deg,'+shades.map((s,i)=>`${s} ${i*100/shades.length}%,${s} ${(i+1)*100/shades.length}%`).join(',')+')';
          else a.style.backgroundColor='#dedbd5';
        }
        list.append(a);
      }
      if(isDetail) node.append(list); else node.replaceChildren(list,...(group.length>6 ? [document.createTextNode('+'+(group.length-6))]:[]));
    }
  };
  const reveal = () => {
    if(!('IntersectionObserver' in window))return;
    const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');observer.unobserve(e.target);}}),{threshold:0.08});
    document.querySelectorAll('.winter-reveal,.ema-sc,.ema-pr,.ema-brands').forEach(el=>observer.observe(el));
  };
  hydrate();reveal();
  document.querySelectorAll('[data-brand-carousel]').forEach(section=>{const track=section.querySelector('[data-brand-track]');section.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:(button.hasAttribute('data-brand-next')?1:-1)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})));});
  const compact=document.querySelectorAll('.compact-menu,.compact-search');
  compact.forEach(panel=>panel.addEventListener('toggle',()=>{if(panel.open)compact.forEach(other=>{if(other!==panel)other.open=false;});}));
  document.addEventListener('click',event=>compact.forEach(panel=>{if(!panel.contains(event.target))panel.open=false;}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')compact.forEach(panel=>{if(panel.open){panel.open=false;panel.querySelector('summary').focus();}});});
  addEventListener('scroll',()=>document.querySelector('.compact-header')?.classList.toggle('is-scrolled',scrollY>30),{passive:true});
  document.querySelectorAll('[data-collection-sort]').forEach(select=>select.addEventListener('change',()=>select.closest('form').requestSubmit()));
  document.addEventListener('shopify:section:load',()=>hydrate());
  let scheduled=false;
  new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;hydrate();});}).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.winter-menu[open]').forEach(d=>d.open=false);});
  document.addEventListener('click',event=>document.querySelectorAll('.winter-menu[open]').forEach(d=>{if(!d.contains(event.target))d.open=false;}));
})();
